import { render, staticRenderFns } from "./VideoCapture.vue?vue&type=template&id=7246ae84&"
import script from "./VideoCapture.vue?vue&type=script&lang=js&"
export * from "./VideoCapture.vue?vue&type=script&lang=js&"
import style0 from "./VideoCapture.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports